export var TERM_TYPES;
(function (TERM_TYPES) {
    TERM_TYPES["V1"] = "v1";
})(TERM_TYPES || (TERM_TYPES = {}));
export const LAST_TERMS_AND_CONDITIONS_VERSION = 'v1';
